module.exports = __webpack_public_path__ + "img/trustpay.4e35aa60.svg";